import { defineComponent as _defineComponent } from 'vue'
import ElButton from 'element/ElButton'
import { streamerAuthorize } from 'lib/api/modules/auth/streamer-auth'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialButton',
  props: {
    requestUrl: null,
    icon: null,
    disabled: { type: Boolean },
    plain: { type: Boolean },
    attaching: { type: Boolean },
    attached: { type: Boolean },
    demoAuth: { type: Boolean }
  },
  emits: ['open-scope'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  requestUrl: string
  icon?: string
  disabled?: boolean
  plain?: boolean
  attaching?: boolean
  attached?: boolean
  demoAuth?: boolean
}





const loading = ref(false)

const auth = async () => {
  if (props.disabled || props.attached) return

  if (props.demoAuth) {
    localStorage.removeItem('is-streamer-demo')
  }

  try {
    loading.value = true
    window.location = await streamerAuthorize(props.requestUrl)
  }
  catch (error) {
    loading.value = false
  }
}

expose({
  auth,
})

return { __sfc: true,props, emit, loading, auth, ElButton }
}

})